/**
 * Update date: 15-05-2023
 * Screen 1044.2
 */
import React, { useRef, useState } from 'react';
import Form from 'devextreme-react/form';
import Collapse from 'app/components/Collapse';
import PopupSelectCommonCode from 'app/components/PopupCommon/PopupSelectCommonCode';
import { uniqBy } from 'lodash';
import { useRegisteringStore } from '..';

const listTypeCommon = {
  storeType: {
    codeType: 'ST',
    title: 'Search Member Store Type',
  },
};

const FormSearch = () => {
  const context: any = useRegisteringStore();
  const { params, refetchData, setParams, t } = context;
  const formRef: any = useRef(null);
  const [showPopupByType, setShowPopupByType] = useState('');

  /**
   * Onsubmit form search
   *
   * @return {*} 
   */
  const onSubmit = async () => {
    if (formRef?.current && !formRef?.current?.instance?.validate()?.isValid)
      return;
    const data = {
      ...params,
      storeType: params?.formStore?.storeType.map((o: any) => o?.code),
    };
    delete data.formStore;
    refetchData({
      data,
    });
  };
  /**
   * get popup by type
   *
   * @param {string} popupType
   * @return {*} 
   */
  const getPopupByType = (popupType: string) => {
    switch (popupType) {
      case 'storeType':
        return (
          <PopupSelectCommonCode
            visible={!!listTypeCommon?.[popupType]?.codeType}
            text={params?.[popupType]}
            codeType={listTypeCommon?.[popupType]?.codeType}
            mode="multiple"
            onHiding={() => setShowPopupByType('')}
            onSubmit={data => updateStore(popupType, data, 'code')}
          />
        );
      default:
        return null;
    }
  };
  /**
   * update store
   *
   * @param {*} storeType
   * @param {*} data
   * @param {*} [key=false]
   */
  const updateStore = (storeType, data, key: any = false) => {
    const filterData = uniqBy(
      [...params?.formStore?.[storeType], ...data],
      key,
    );
    const newStore = { ...params?.formStore, [storeType]: filterData };
    setParams(preState => ({
      ...preState,
      [storeType]: '',
      formStore: newStore,
    }));
    setShowPopupByType('');
  };
  /**
   * remove store
   *
   * @param {*} storeType
   * @param {*} index
   */
  const removeStore = (storeType, index) => {
    let newStore;
    if (index === -1) {
      setParams(preState => ({
        ...preState,
        formStore: {
          ...preState?.formStore,
          [storeType]: [],
        },
      }));
    } else {
      const l = [...params?.formStore[storeType]];
      newStore = [...l.slice(0, index), ...l.slice(index + 1)];
      setParams(preState => ({
        ...preState,
        formStore: {
          ...preState?.formStore,
          [storeType]: newStore,
        },
      }));
    }
  };
  /**
   * render search
   *
   * @param {*} { name }
   * @return {*} 
   */
  const Search = ({ name }) => {
    return (
      <>
        <Form
          formData={params}
          showColonAfterLabel={false}
          ref={formRef}
          items={[
            {
              label: {
                text: t('Store Name'),
              },
              dataField: 'storeName',
              editorType: 'dxTextBox',
            },
            {
              dataField: 'storeType',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => {
                  setShowPopupByType('storeType');
                },
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.storeType[0]?.name,
                      onClick: () => removeStore('storeType', 0),
                      visible: !!params?.formStore?.storeType[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.storeType[1]?.name,
                      onClick: () => removeStore('storeType', 1),
                      visible: !!params?.formStore?.storeType[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'storeMore',
                    location: 'before',
                    options: {
                      text: `+ ${params?.formStore?.storeType?.length - 2} ${t(
                        'more',
                      )}`,
                      visible: params?.formStore?.storeType?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.storeType?.length,
                      onClick: () => removeStore('storeType', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('storeType'),
                    },
                  },
                ],
              },
              label: {
                text: t('Store Type'),
              },
            },
            {
              label: { text: t('Use') },
              dataField: 'use',
              editorType: 'dxTagBox',
              editorOptions: {
                displayExpr: 'label',
                valueExpr: 'value',
                items: [
                  {
                    label: t('Use'),
                    value: true,
                  },
                  {
                    label: t('Not Use'),
                    value: false,
                  },
                ],
              },
            },
            {
              label: {
                text: t('Representative'),
              },
              dataField: 'representative',
              editorType: 'dxTextBox',
            },
          ]}
          labelLocation="top"
          colCount={2}
        />
      </>
    );
  };
  return (
    <div>
      <Collapse onSubmit={onSubmit}>
        <Search name={t('Search')} />
      </Collapse>
      {getPopupByType(showPopupByType)}
    </div>
  );
};

export default FormSearch;
